import { createPortal } from "react-dom";
import {
  createContext,
  useContext,
  useLayoutEffect,
  type ReactNode,
} from "react";

export const ExperimentalSearchOverlayContext = createContext<
  | {
      container: HTMLDivElement | null;
      onOverlayOpenChange: (isOpen: boolean) => void;
    }
  | undefined
>(undefined);

export const ExperimentalSearchOverlayContextProvider =
  ExperimentalSearchOverlayContext.Provider;

export const ExperimentalSearchOverlay = ({
  children,
}: {
  children: ReactNode;
}) => {
  const searchOverlayContext = useContext(ExperimentalSearchOverlayContext);
  if (!searchOverlayContext)
    throw new Error(
      "ExperimentalSearchOverlay must have an access to ExperimentalSearchOverlayContext",
    );
  const { container, onOverlayOpenChange } = searchOverlayContext;

  useLayoutEffect(() => {
    onOverlayOpenChange(true);

    return () => onOverlayOpenChange(false);
  }, [onOverlayOpenChange]);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
